module.exports = __webpack_public_path__ + "static/img/dreamWearSiliconePillowMask.317b585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/dreamWearSiliconePillowMask.png
// module id = EKCn
// module chunks = 1